import axios from "axios";

let uegCrm = axios.create({
  headers: {}
});

export default {
  namespaced: true,
  state: {
    selectedAuthor: null,
    selectedInstitute: null
  },
  actions: {
    GET_AUTHORS: function ({commit, state}, search) {
      return uegCrm.get(process.env.VUE_APP_UEG_CRM + '/contact?' + search.query + '&_token=' + search.token)
    },
    GET_AUTHOR: function ({commit, state}, search) {
      return uegCrm.get(process.env.VUE_APP_UEG_CRM + '/contact?id=' + search.id + '&_token=' + search.token)
    },
  },
  mutations: {
    SET_SELECTEDAUTHOR: (state, {selectedAuthor}) => {
      state.selectedAuthor = selectedAuthor
    },
    SET_SELECTEDINSTITUTE: (state, {selectedInstitute}) => {
      state.selectedInstitute = selectedInstitute
    },
  },
  getters: {}
}
